<template>
  <UISkeletonTree
    v-if="isLoading"
    message="Loading clients..."
  />
  <AppTree
    v-else
    :data
    :formatter
    :active-path
    hide-actions
    disable-slots
    placeholder="Search clients..."
    @click:node="handleClickNode"
  />
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'
import { useRouter } from 'vue-router'

import { AnalyticsField } from '@types'

import { ROUTE_NAME, SET_CURRENT_REPOSITORY, UNKNOWN_VALUE } from '@/const'

import { useAdvisorStore } from '@/store/advisor'

import { AppTree } from '@app'
import { UISkeletonTree } from '@ui/skeletons'

const advisorStore = useAdvisorStore()

const router = useRouter()

const setCurrentRepository = inject<(id?: string) => void>(SET_CURRENT_REPOSITORY)

const clients = computed(() => advisorStore.getClients)
const totals = computed(() => advisorStore.getTotals)

const activePath = computed(() => {
  const path: string[] = [AnalyticsField.REPO_ROOT]
  const clientId = advisorStore.getSelectedClient
  if (clientId) {
    path.push(clientId)
  }
  return path
})

const data = computed(() => ({ [AnalyticsField.REPO_ROOT]: Object.fromEntries(
  clients.value.map(client => [client.id, {
    path: [AnalyticsField.REPO_ROOT, client.id],
    balance: totals.value.get(client.id) || 0,
  }]))
}))
const isLoading = computed(() => advisorStore.loading)


const formatter = (key: string) => {
  if (key === AnalyticsField.REPO_ROOT) {
    return 'All clients'
  }
  return clients.value.find(client => client.id === key)?.name || UNKNOWN_VALUE
}

const handleClickNode = (path: string[]) => {
  const clientId = path.at(-1)
  if (!clientId || clientId === AnalyticsField.REPO_ROOT) return
  setCurrentRepository?.(clientId)
  router.push({ name: ROUTE_NAME.DASHBOARDS })
}
</script>
